"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("@design/lib/utils");
var _sheet = require("@design/ui/sheet");
var _backButton = _interopRequireDefault(require("./back-button"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function BackSheet(_ref) {
  var title = _ref.title,
    backLabel = _ref.backLabel,
    onBack = _ref.onBack,
    className = _ref.className,
    children = _ref.children,
    ref = _ref.ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_sheet.Sheet, {
    open: true,
    modal: false,
    "data-sentry-element": "Sheet",
    "data-sentry-component": "BackSheet",
    "data-sentry-source-file": "back-sheet.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_sheet.SheetContent, {
      ref: ref,
      side: "right",
      showCloseButton: false,
      "aria-describedby": undefined,
      onInteractOutside: function onInteractOutside(event) {
        return event.preventDefault();
      },
      onEscapeKeyDown: function onEscapeKeyDown(event) {
        return event.preventDefault();
      },
      className: (0, _utils.cn)("gap-0 bg-white text-[length:inherit] text-inherit shadow-none data-[side=right]:border-l-0 data-[side=right]:h-[calc(100vh-42px)]", className),
      "data-sentry-element": "SheetContent",
      "data-sentry-source-file": "back-sheet.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-shrink-0 items-center gap-2 px-4 pt-4 pb-2",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_backButton.default, {
          onClick: onBack,
          ariaLabel: backLabel,
          "data-sentry-element": "BackButton",
          "data-sentry-source-file": "back-sheet.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_sheet.SheetTitle, {
          "data-sentry-element": "SheetTitle",
          "data-sentry-source-file": "back-sheet.tsx",
          children: title
        })]
      }), children]
    })
  });
}
var _default = exports.default = BackSheet;